jQuery(document).ready(function ($) {
  // Enable tooltips for elements with the title attribute
  // $('[title]').tooltip();

  $(window).scroll(function () {
    var scroll = $(window).scrollTop();
    if (scroll >= 5) {
      $(".header").addClass("darkHeader");
    } else {
      $(".header").removeClass("darkHeader");
    }
  });
  var scroll = $(window).scrollTop();
  if (scroll >= 5) {
    $(".header").addClass("darkHeader");
  } else {
    $(".header").removeClass("darkHeader");
  }

  //dropdown meag menus
  $("a.has_more_childs").click(function (event) {
    event.preventDefault();

    //displaying next level menu
    if ($(this).hasClass("second_level_link")) {
      if ($(this).hasClass("active")) {
        $(".custom_third_level").css("opacity", "0");
        $(".custom_third_level").css("transform", "translateX(-100%)");
        $(".custom_third_level").css("visibility", "hidden");
        $(".custom_fourth_level").css("opacity", "0");
        $(".custom_fourth_level").css("transform", "translateX(-100%)");
        $(".custom_fourth_level").css("visibility", "hidden");
        $("a.has_more_childs.active").removeClass("active");

        //style css for a
        $(this).css("opacity", ".5");
        $(this).find(".caret_custom").css("transform", "rotate(270deg)");
      } else {
        $(".has_more_childs").removeClass("active");
        $(this).addClass("active");
        $(".custom_third_level").css("opacity", "0");
        $(".custom_third_level").css("transform", "translateX(-100%)");
        $(".custom_third_level").css("visibility", "hidden");
        $(".custom_fourth_level").css("opacity", "0");
        $(".custom_fourth_level").css("transform", "translateX(-100%)");
        $(".custom_fourth_level").css("visibility", "hidden");

        $(this).siblings(".custom_third_level").css("opacity", "1");
        $(this)
          .siblings(".custom_third_level")
          .css("transform", "translateX(0)");
        $(this).siblings(".custom_third_level").css("visibility", "visible");

        //style css for a
        $(".has_more_childs").css("opacity", ".5");
        $(".has_more_childs")
          .find(".caret_custom")
          .css("transform", "rotate(270deg)");
        $(this).addClass("active");
        $(this).css("opacity", "1");
        $(this).find(".caret_custom").css("transform", "rotate(90deg)");
      }
    }
    if ($(this).hasClass("third_level_link")) {
      if ($(this).hasClass("active")) {
        $(".custom_fourth_level").css("opacity", "0");
        $(".custom_fourth_level").css("transform", "translateX(-100%)");
        $(".custom_fourth_level").css("visibility", "hidden");
        $("a.has_more_childs.active").removeClass("active");

        //style css for a
        $(this).css("opacity", ".5");
        $(this).find(".caret_custom").css("transform", "rotate(270deg)");
      } else {
        $(".has_more_childs").removeClass("active");
        $(this).addClass("active");
        $(".custom_fourth_level").css("opacity", "0");
        $(".custom_fourth_level").css("transform", "translateX(-100%)");
        $(".custom_fourth_level").css("visibility", "hidden");

        $(this).siblings(".custom_fourth_level").css("opacity", "1");
        $(this)
          .siblings(".custom_fourth_level")
          .css("transform", "translateX(0)");
        $(this).siblings(".custom_fourth_level").css("visibility", "visible");

        //style css for a
        $(".third_level_link.has_more_childs").css("opacity", ".5");
        $(".third_level_link.has_more_childs")
          .find(".caret_custom")
          .css("transform", "rotate(270deg)");
        $(this).addClass("active");
        $(this).css("opacity", "1");
        $(this).find(".caret_custom").css("transform", "rotate(90deg)");
      }
    }
  });

  //check parent and making them active if some anchor is active
  if ($(".main_outer_menu a.mega-menu__link--active").length > 0) {
    if (
      $(".main_outer_menu a.mega-menu__link--active.second_level_link")
        .length == 0
    ) {
      // Perform your function here
      // For example, you can add more styling or trigger another action
      var activeAnchor = $(
        ".main_outer_menu a.mega-menu__link--active"
      ).first();

      // Get the reference to the ul element that is the parent of the li containing the active anchor
      var parentUl = activeAnchor.parentsUntil("ul");
      // var classes = parentUl.attr('class').split(' ');
      // console.log(classes);
      parentUl.css("opacity", "1");
      parentUl.css("transform", "translateX(0)");
      parentUl.css("visibility", "visible");
      var prevAnchor = parentUl.prev("a");
      console.log("A: " + prevAnchor);

      // Apply CSS styles to the anchor element
      prevAnchor.addClass("active");
      prevAnchor.css({
        // Add your desired styles here
        opacity: "1",
        "text-decoration": "underline",
      });

      prevAnchor.find(".caret_custom").css("transform", "rotate(90deg)");

      // Get references to any other parent ul elements within the main_outer_menu element
      var parentUls = parentUl.parents(".main_outer_menu ul");
      if (parentUls.length > 0) {
        parentUls.each(function () {
          if (!$(this).hasClass("custom_second_level")) {
            $(this).css({
              opacity: "1",
              transform: "translateX(0)",
              visibility: "visible",
            });

            var prevAnchor = $(this).prev("a");
            console.log("A: " + prevAnchor);

            // Apply CSS styles to the anchor element
            prevAnchor.addClass("active");
            prevAnchor.css({
              // Add your desired styles here
              opacity: "1",
              "text-decoration": "underline",
            });

            prevAnchor.find(".caret_custom").css("transform", "rotate(90deg)");
          }
        });
      }
    }
  } else {
    //making shop>prints>by subject active initially
    $(".main_outer_menu")
      .find(".custom_second_level li")
      .each(function () {
        // Get the anchor tag inside the current li element
        var anchor = $(this).find("a:first");

        // Check if the text of the anchor tag is "Prints"
        if (anchor.text().trim().toUpperCase() === "BY SUBJECT MATTER") {
          // Add styling to the caret_custom class inside the anchor
          anchor.find(".caret_custom").css("transform", "rotate(90deg)");
          anchor.css("opacity", "1");
          anchor.addClass("active");

          // Add styling to the sibling ul element
          anchor.siblings("ul").css({
            opacity: "1",
            transform: "translateX(0)",
            visibility: "visible",
          });

          // Target the "By Subject Matter" anchor within the same li
          var subjectMatterAnchor = $(this)
            .find("a")
            .filter(function () {
              // return $(this).text().trim().toUpperCase() === "BY SUBJECT MATTER";
              var isMatch =
                $(this).text().trim().toUpperCase() === "BY SUBJECT MATTER";
              if (isMatch) {
                $(this).addClass("active");
              }
              return isMatch;
            });

          // Check if "By Subject Matter" anchor exists
          if (subjectMatterAnchor.length > 0) {
            // Add styling to the caret_custom class inside the "By Subject Matter" anchor
            subjectMatterAnchor
              .find(".caret_custom")
              .css("transform", "rotate(90deg)");
            subjectMatterAnchor.css("opacity", "1");

            // Add styling to the sibling ul element of the "By Subject Matter" anchor
            subjectMatterAnchor.siblings("ul").css({
              opacity: "1",
              transform: "translateX(0)",
              visibility: "visible",
            });
          }
        }
      });
  }

  //shop hover style for desktop
  $(".shop_menu_mega").hover(
    function () {
      // Function to run when mouse enters the element
      $(this).find("details:first").attr("open", "");
      //   $(".header").css("background", "white");
      //   $(".header").css("transition", "none");
      $(".header").addClass("customDark");

      // Set 'aria-expanded' attribute of 'summary' element to 'true'
      $(this).find("summary:first").attr("aria-expanded", "true");
      $(this)
        .find("summary:first + .mega-menu__content")
        .css("transition", "all .5s ease-in-out .02s");
    },
    function () {
      // Function to run when mouse leaves the element
      //   $(".header").css("background", "transparent");
      $(".header").removeClass("customDark");
    }
  );
  //header__inline-menu
  $(".header__inline-menu .list-menu--inline > li").hover(
    function () {
      // Function to run when mouse enters the element
      if (!$(this).hasClass("shop_menu_mega")) {
        $(".shop_menu_mega").find("details:first").removeAttr("open");
        $(".shop_menu_mega")
          .find("summary:first")
          .attr("aria-expanded", "false");
      }
    },
    function () {
      // Function to run when mouse leaves the element
    }
  );

  //prventing click funtion on dropdown
  // $(".shop_menu_mega").find('details:first').click(function (event) {
  //     event.preventDefault();
  // });
  //hide dropdown when clicked outside of the dropdown
  $(document).on("click", function (event) {
    // Check if the clicked element is not a descendant of the .sticky-header
    if (!$(event.target).closest(".mega-menu__content").length) {
      $(".shop_menu_mega").find("details:first").removeAttr("open");

      // Set 'aria-expanded' attribute of 'summary' element to 'true'
      $(".shop_menu_mega").find("summary:first").attr("aria-expanded", "false");
      $(".header").css("background", "transparent");
      $(".header").css("transition", "all 1s ease .1s");
    }
  });

  //faq page accordion
  $(".faqs .block:first").addClass("active");
  $(".faqs .block:first").find(".answer").slideDown();
  $(".faqs .block .inline").click(function () {
    if ($(this).parent().parent().hasClass("active")) {
      $(this).parent().parent().removeClass("active");
      $(this).parent().parent().find(".answer").slideUp();
    } else {
      $(".faqs .block").removeClass("active");
      $(".faqs .block").find(".answer").slideUp();
      $(this).parent().parent().addClass("active");
      $(this).parent().parent().find(".answer").slideDown();
    }
  });

  //event page scrip[ts
  $(".event_btn:first").addClass("active");
  var active_event_content = $(".event_btn:first").attr("data-active-event");
  $("." + active_event_content).slideDown();

  // $(".event_btn").click(function(){
  //     $(".event_btn").removeClass("active");
  //     $(this).addClass("active");
  //     active_event_content = $(this).attr("data-active-event")
  //     $(".events_content").slideUp();
  //     $("." + active_event_content).slideDown();
  // });

  //login page
  function timeout_login() {
    if (window.location.href.indexOf("#recover") > -1) {
      // alert("contain recoverssss");
      $(".login_form_page_area").hide();
    } else if (window.location.href.indexOf("#login") > -1) {
      $(".login_form_page_area").show();
    } else {
      $(".login_form_page_area").show();
    }
  }
  timeout_login();
  var timeoutLogin;
  $("#recover_p").click(function () {
    // localStorage.setItem('hide_login_form_area', 'true');
    // $(".login_form_page_area").hide();
    // alert("recover_p clicked");
    clearTimeout(timeoutLogin);
    timeoutLogin = setTimeout(timeout_login, 5);
  });
  $("#recover_cancel").click(function () {
    // alert("recover_cancel clicked");
    clearTimeout(timeoutLogin);
    timeoutLogin = setTimeout(timeout_login, 5);
  });

  // disabling checkout if required checkbox
  // $(".cart__check").css("display", "none");
  // if ($("#required_final_sale").is(":checked")) {
  //     $(".cart__check").css("display", "grid");
  // } else {
  //     $(".cart__check").css("display", "none");
  // }
  // if ($("body").hasClass("template-cart")) {
  //     $(".cart__check").addClass("disabled");
  //     $(".cart__check.disabled").click(function (e) {
  //     e.stopPropagation();
  //     });
  // }
  // Function to check for value changes in hidden inputs

  $("#required_final_sale").change(function () {
    // Check if the checkbox is checked
    if ($(this).is(":checked")) {
      $(".cart__check").css("display", "grid");
    } else {
      $(".cart__check").css("display", "none");
    }
  });

  ////////////  PRODUCT PAGE  ////////////
  //sliders
  $(".prd_images .top_section .image_slider").slick({
    infinite: false,
    autoplay: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: false,
    arrows: true,
    touchMove: false,
    prevArrow: ".prd_images .top_section .prev",
    nextArrow: ".prd_images .top_section .next",
    asNavFor: ".prd_images .bottom_section .image_slider",
  });
  $(".prd_images .bottom_section .image_slider").slick({
    infinite: false,
    autoplay: false,
    // autoplaySpeed: 5000,
    slidesToShow: 5,
    // slidesToScroll: 1,
    arrows: false,
    asNavFor: ".prd_images .top_section .image_slider",
    focusOnSelect: true,
    centerMode: false,
    responsive: [
      {
        breakpoint: 3400,
        settings: {
          centerMode: false,
          slidesToShow: 5,
        },
      },
      {
        breakpoint: 1600,
        settings: {
          centerMode: false,
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 1400,
        settings: {
          centerMode: false,
          slidesToShow: 3,
        },
      },
    ],
  });
  //sliders
  function resetAndGoToSlideMatchingAlt(targetAlt) {
    const $topSlider = $(".prd_images .top_section .image_slider");
    const $bottomSlider = $(".prd_images .bottom_section .image_slider");

    // Destroy both sliders
    if ($topSlider.hasClass("slick-initialized")) {
      $topSlider.slick("unslick");
    }
    if ($bottomSlider.hasClass("slick-initialized")) {
      $bottomSlider.slick("unslick");
    }

    // Re-init sliders
    $topSlider.slick({
      infinite: false,
      autoplay: false,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      fade: false,
      arrows: true,
      touchMove: false,
      prevArrow: ".prd_images .top_section .prev",
      nextArrow: ".prd_images .top_section .next",
      asNavFor: ".prd_images .bottom_section .image_slider",
    });

    $bottomSlider.slick({
      // infinite: false,
      // autoplay: false,
      // slidesToShow: 4,
      // slidesToScroll: 1,
      // arrows: false,
      // asNavFor: '.prd_images .top_section .image_slider',
      // focusOnSelect: true,
      // responsive: [
      //     {
      //         breakpoint: 4200,
      //         settings: {
      //             centerMode: false,
      //             slidesToShow: 4,
      //         }
      //     },
      //     {
      //         breakpoint: 1500,
      //         settings: {
      //             centerMode: false,
      //             slidesToShow: 3,
      //         }
      //     },
      //     {
      //         breakpoint: 1400,
      //         settings: {
      //             centerMode: false,
      //             slidesToShow: 3,
      //         }
      //     }
      // ]
      infinite: false,
      autoplay: false,
      // autoplaySpeed: 5000,
      slidesToShow: 5,
      // slidesToScroll: 1,
      arrows: false,
      asNavFor: ".prd_images .top_section .image_slider",
      focusOnSelect: true,
      centerMode: false,
      responsive: [
        {
          breakpoint: 3400,
          settings: {
            centerMode: false,
            slidesToShow: 5,
          },
        },
        {
          breakpoint: 1600,
          settings: {
            centerMode: false,
            slidesToShow: 4,
          },
        },
        {
          breakpoint: 1400,
          settings: {
            centerMode: false,
            slidesToShow: 3,
          },
        },
      ],
    });

    // Delay to let Slick rebuild DOM
    setTimeout(() => {
      // Find the new visible slides and match by alt
      let targetIndex = null;
      $(".prd_images .bottom_section .image_slider .slide_child:visible").each(
        function (index) {
          const alt = $(this)
            .find("img.mainImg")
            .attr("alt")
            ?.trim()
            .toLowerCase();
          if (alt === targetAlt.toLowerCase()) {
            targetIndex = index;
            return false; // break loop
          }
        }
      );

      if (targetIndex !== null) {
        // Go to matched slide
        $topSlider.slick("slickGoTo", targetIndex);
      }
    }, 350); // Let Slick re-initialize and layout before going to slide
  }

  //initial settings
  var choose_product_inputs = document.querySelectorAll(
    'input[name^="Choose Product"]'
  );
  var frame_color_inputs = document.querySelectorAll(
    'input[name^="Frame Colour"]'
  );

  let currentFilterOnLoad = null; // This tracks which filter is currently applied
  let currentFilter = null; // This tracks which filter is currently applied

  // Function to handle the logic based on the input value for product type
  function checkVariantValue(input) {
    console.log("Checking variant onload option:", input.value);
    if (input.checked) {
      if (input.value === "Canvas") {
        //showing info block
        $(".block_canvas").css("display", "block");
        $(".block_framed_canvas").css("display", "none");
        $(".block_framed_print").css("display", "none");
        $(".block_rolled_canvas").css("display", "none");
        $(".block_rolled_paper").css("display", "none");

        $("#block_Frame_Colour").hide();

        console.log("noBorder");
        //FRAME CLASS BETWEEN 'noBorder', 'canFrame', 'bigBor'
        $(".slide_child").find(".main").removeClass("canFrame");
        $(".slide_child").find(".main").removeClass("bigBor");
        $(".slide_child").find(".main").addClass("noBorder");
        //FRAME CLASS BETWEEN 'noBorder', 'canFrame', 'bigBor'
      }
      // else if(input.value == "Framed Canvas"){ //canFrame
      else if (input.value == "Framed Canvas") {
        //canFrame

        //showing info block
        $(".block_canvas").css("display", "none");
        $(".block_framed_canvas").css("display", "block");
        $(".block_framed_print").css("display", "none");
        $(".block_rolled_canvas").css("display", "none");
        $(".block_rolled_paper").css("display", "none");

        console.log("canFrame");

        //FRAME CLASS BETWEEN 'noBorder', 'canFrame', 'bigBor'
        $(".slide_child").find(".main").removeClass("noBorder");
        $(".slide_child").find(".main").removeClass("bigBor");
        $(".slide_child").find(".main").addClass("canFrame");
        //FRAME CLASS BETWEEN 'noBorder', 'canFrame', 'bigBor'

        //showing color block
        $("#block_Frame_Colour").slideDown();
      } else if (input.value == "Framed Print") {
        //bigBor
        console.log("bigBor");

        //showing info block
        $(".block_canvas").css("display", "none");
        $(".block_framed_canvas").css("display", "none");
        $(".block_framed_print").css("display", "block");
        $(".block_rolled_canvas").css("display", "none");
        $(".block_rolled_paper").css("display", "none");

        //FRAME CLASS BETWEEN 'noBorder', 'canFrame', 'bigBor'
        $(".slide_child").find(".main").removeClass("noBorder");
        $(".slide_child").find(".main").removeClass("canFrame");
        $(".slide_child").find(".main").addClass("bigBor");
        //FRAME CLASS BETWEEN 'noBorder', 'canFrame', 'bigBor'

        //showing color block
        $("#block_Frame_Colour").slideDown();
      } else if (input.value == "Rolled Canvas") {
        //rolled canvas
        console.log("noneeee rollded canvas");
        //showing info block
        $(".block_canvas").css("display", "none");
        $(".block_framed_canvas").css("display", "none");
        $(".block_framed_print").css("display", "none");
        $(".block_rolled_canvas").css("display", "block");
        $(".block_rolled_paper").css("display", "none");
      } else if (input.value == "Rolled Paper") {
        //rolled canvas
        console.log("noneeee rollded paper");
        //showing info block
        $(".block_canvas").css("display", "none");
        $(".block_framed_canvas").css("display", "none");
        $(".block_framed_print").css("display", "none");
        $(".block_rolled_canvas").css("display", "none");
        $(".block_rolled_paper").css("display", "block");
      }

      //// WORKING 1 ////
      var $slider = $(".image_slider");
      if ($slider.hasClass("slick-initialized")) {
        if (currentFilter !== null) {
          $slider.slick("slickUnfilter");
          currentFilter = null;
        }

        if (input.value === "Rolled Canvas" || input.value === "Rolled Paper") {
          $slider.slick("slickFilter", ".rolled_canvas_paper");
          currentFilter = ".rolled_canvas_paper";
        } else {
          $slider.slick("slickFilter", ".non_rolled");
          currentFilter = ".non_rolled";
        }
      } else {
        console.warn("Slick not initialized yet");
      }
      //// WORKING 1 ////

      //// TEST 1 ////
      // var $slider = $('.image_slider');

      // if ($slider.hasClass('slick-initialized')) {
      //     console.log('Slick initialized!');
      //     if (currentFilter !== null) {
      //         $slider.slick('slickUnfilter');
      //         currentFilter = null;
      //         console.log('not null!');
      //     }

      //     // Apply new filter
      //     if (input.value === "Rolled Canvas" || input.value === "Rolled Paper") {
      //         $slider.slick('slickFilter', '.rolled_canvas_paper');
      //         currentFilter = '.rolled_canvas_paper';
      //         console.log('rolled or paper!');
      //     } else {
      //         $slider.slick('slickFilter', '.non_rolled');
      //         currentFilter = '.non_rolled';
      //         console.log('not rolled or paper!');
      //     }

      //     // Wait a moment to ensure filtering is applied before trying to jump to the correct slide
      //     setTimeout(function () {
      //         const targetAlt = input.value.trim().toLowerCase();
      //         let targetIndex = null;

      //         console.log('in time out!');

      //         $('.image_slider .slide_child:visible').each(function (index) {
      //             console.log('in each function!');
      //             const alt = $(this).find('img.mainImg').attr('alt')?.trim().toLowerCase();
      //             console.log('alt!', alt);
      //             console.log('alt!', alt);
      //             if (alt && alt === targetAlt) {
      //                 console.log('in if block!');
      //                 targetIndex = index;
      //                 console.log('targetIndex!', targetIndex);
      //                 return false; // break the loop
      //             }
      //         });

      //         // if (targetIndex !== null) {
      //         //     // ✅ Trigger layout recalculation
      //         //     $slider.slick('setPosition');
      //         //     setTimeout(function () {
      //         //         console.log('in target not nullss!');
      //         //         // 🔥 Force layout recalculation
      //         //         // $slider.slick('setPosition');
      //         //         $slider.slick('slickGoTo', targetIndex);
      //         //     }, 350);
      //         // }
      //         if (targetIndex !== null) {
      //             // Give Slick time to apply filtering
      //             setTimeout(() => {
      //                 // ✅ Trigger full layout recalculation
      //                 $slider.slick('setPosition');

      //                 // ✅ Go to correct slide only after images are laid out
      //                 requestAnimationFrame(() => {
      //                     $slider.slick('slickGoTo', targetIndex);

      //                     // ✅ Optional: Force re-layout if still stacked
      //                     setTimeout(() => {
      //                         $slider.slick('setPosition');
      //                     }, 100);
      //                 });
      //             }, 350);
      //         }
      //     }, 150);
      // } else {
      //     console.log('Slick not initialized yet');
      // }
      //// TEST 1 ////

      //// TEST 2 ////
      // resetAndGoToSlideMatchingAlt("Rolled Canvas");
      //// TEST 2 ////
    }
  }
  // Function to handle the logic based on the input value for frame colour
  function checkVariantFrameColor(input) {
    console.log("Checking variant frma color:", input.value);
    if (input.checked) {
      if (input.value == "Classic Black Frame") {
        //change frame border image respective to the selected color
        $(".slide_child").find(".main").css({
          "border-image":
            "url('https://cdn.shopify.com/s/files/1/0874/3016/8858/files/frame_black_26x26_9e780e5d-510f-4f8b-8023-049c6ab5bea0.png?v=1716473301') 66 / 10 / 1",
          "-o-border-image":
            "url('https://cdn.shopify.com/s/files/1/0874/3016/8858/files/frame_black_26x26_9e780e5d-510f-4f8b-8023-049c6ab5bea0.png?v=1716473301') 66 / 10 / 1",
        });
      } else if (input.value == "Classic Brown Frame") {
        //canFrame
        //change frame border image respective to the selected color
        $(".slide_child").find(".main").css({
          "border-image":
            "url('https://cdn.shopify.com/s/files/1/0874/3016/8858/files/frame_brown_24x24_b1ab1988-010f-4780-b926-9906dbb6a12c.png?v=1716472579') 66 / 10 / 1",
          "-o-border-image":
            "url('https://cdn.shopify.com/s/files/1/0874/3016/8858/files/frame_brown_24x24_b1ab1988-010f-4780-b926-9906dbb6a12c.png?v=1716472579') 66 / 10 / 1",
        });
      } else if (input.value == "Classic White Frame") {
        //bigBor
        //change frame border image respective to the selected color
        $(".slide_child").find(".main").css({
          "border-image":
            "url('https://cdn.shopify.com/s/files/1/0874/3016/8858/files/frame_white_test.png?v=1716478833') 66 / 10 / 1",
          "-o-border-image":
            "url('https://cdn.shopify.com/s/files/1/0874/3016/8858/files/frame_white_test.png?v=1716478833') 66 / 10 / 1",
        });
      }
    }
  }

  // Traverse through each input and check the value on page load if it's checked
  //for product type
  choose_product_inputs.forEach(function (input) {
    if (input.checked) {
      checkVariantValue(input);
    }
  });
  //for product type
  frame_color_inputs.forEach(function (input) {
    if (input.checked) {
      checkVariantFrameColor(input);
    }
  });

  //following function will run when value of product type option is changed
  //hiding frame colour option for product type canvas
  document
    .querySelectorAll('input[name^="Choose Product"]')
    .forEach(function (selectElement) {
      selectElement.addEventListener("change", function (event) {
        console.log("Variant option changeed new:", event.target.value);
        if (event.target.value == "Canvas") {
          //showing info block
          $(".block_canvas").css("display", "block");
          $(".block_framed_canvas").css("display", "none");
          $(".block_framed_print").css("display", "none");
          $(".block_rolled_canvas").css("display", "none");
          $(".block_rolled_paper").css("display", "none");

          $("#block_Frame_Colour").hide();
          if (frame_color_inputs.length > 1) {
            var secondInput = frame_color_inputs[0];
            secondInput.checked = true;
            var event = new Event("change");
            secondInput.dispatchEvent(event);
            // secondInput.click();
          }
          console.log("noBorder");
          //FRAME CLASS BETWEEN 'noBorder', 'canFrame', 'bigBor'
          $(".slide_child").find(".main").removeClass("canFrame");
          $(".slide_child").find(".main").removeClass("bigBor");
          $(".slide_child").find(".main").addClass("noBorder");
          //FRAME CLASS BETWEEN 'noBorder', 'canFrame', 'bigBor'

          //chnaging frame border image
          $(".slide_child").find(".main").css({
            "border-image":
              "url('https://cdn.shopify.com/s/files/1/0874/3016/8858/files/noframe.webp?v=1716471350') 66",
            "-o-border-image":
              "url('https://cdn.shopify.com/s/files/1/0874/3016/8858/files/noframe.webp?v=1716471350') 66",
          });
        } else if (event.target.value == "Framed Canvas") {
          //canFrame

          //showing info block
          $(".block_canvas").css("display", "none");
          $(".block_framed_canvas").css("display", "block");
          $(".block_framed_print").css("display", "none");
          $(".block_rolled_canvas").css("display", "none");
          $(".block_rolled_paper").css("display", "none");

          //showing color block
          $("#block_Frame_Colour").slideDown();
          if (frame_color_inputs.length > 1) {
            var secondInput = frame_color_inputs[1];
            secondInput.checked = true;
            var event = new Event("change");
            secondInput.dispatchEvent(event);
            // secondInput.click();
          }

          console.log("canFrame");
          //FRAME CLASS BETWEEN 'noBorder', 'canFrame', 'bigBor'
          $(".slide_child").find(".main").removeClass("noBorder");
          $(".slide_child").find(".main").removeClass("bigBor");
          $(".slide_child").find(".main").addClass("canFrame");
          //FRAME CLASS BETWEEN 'noBorder', 'canFrame', 'bigBor'
        } else if (event.target.value == "Framed Print") {
          //bigBor

          //showing info block
          $(".block_canvas").css("display", "none");
          $(".block_framed_canvas").css("display", "none");
          $(".block_framed_print").css("display", "block");
          $(".block_rolled_canvas").css("display", "none");
          $(".block_rolled_paper").css("display", "none");

          //showing color block
          $("#block_Frame_Colour").slideDown();
          if (frame_color_inputs.length > 1) {
            var secondInput = frame_color_inputs[1];
            secondInput.checked = true;
            var event = new Event("change");
            secondInput.dispatchEvent(event);
            // secondInput.click();
          }

          console.log("bigBor");
          //FRAME CLASS BETWEEN 'noBorder', 'canFrame', 'bigBor'
          $(".slide_child").find(".main").removeClass("noBorder");
          $(".slide_child").find(".main").removeClass("canFrame");
          $(".slide_child").find(".main").addClass("bigBor");
          //FRAME CLASS BETWEEN 'noBorder', 'canFrame', 'bigBor'
        } else if (event.target.value == "Rolled Canvas") {
          //rolled canvas
          //showing info block
          $(".block_canvas").css("display", "none");
          $(".block_framed_canvas").css("display", "none");
          $(".block_framed_print").css("display", "none");
          $(".block_rolled_canvas").css("display", "block");
          $(".block_rolled_paper").css("display", "none");
        } else if (event.target.value == "Rolled Paper") {
          //rolled canvas
          //showing info block
          $(".block_canvas").css("display", "none");
          $(".block_framed_canvas").css("display", "none");
          $(".block_framed_print").css("display", "none");
          $(".block_rolled_canvas").css("display", "none");
          $(".block_rolled_paper").css("display", "block");
        }

        ////WORKING 1 ////
        // var $slider = $('.image_slider');

        // // Go to first slide (forces a slide transition visually)
        // // $slider.slick('slickGoTo', 0);

        // // Optional: fade out slider container
        // $slider.css('opacity', 0.5); // or .addClass('fading')

        // setTimeout(function () {
        // // Remove previous filter if applied
        // if (currentFilter !== null) {
        //     $slider.slick('slickUnfilter');
        //     currentFilter = null;
        // }

        // // Apply filter based on variant
        // if (event.target.value === "Rolled Canvas" || event.target.value === "Rolled Paper") {
        //     $slider.slick('slickFilter', '.rolled_canvas_paper');
        //     currentFilter = '.rolled_canvas_paper';
        // } else {
        //     $slider.slick('slickFilter', '.non_rolled');
        //     currentFilter = '.non_rolled';
        // }

        // $slider.slick('slickSetOption', 'fade', true, true);
        // // Optional: fade back in
        // setTimeout(() => $slider.css('opacity', 1), 200);
        // }, 400); // wait long enough to let slick animation start

        ////WORKING 1 ////

        //// TEST 1 ////
        var $slider = $(".image_slider");
        setTimeout(function () {
          if ($(".top_section_content").hasClass("do_filtering")) {
            // Remove previous filter if applied
            if (currentFilter !== null) {
              $slider.slick("slickUnfilter");
              currentFilter = null;
            }

            // Apply filter based on variant
            if (
              event.target.value === "Rolled Canvas" ||
              event.target.value === "Rolled Paper"
            ) {
              $slider.slick("slickFilter", ".rolled_canvas_paper");
              currentFilter = ".rolled_canvas_paper";
            } else {
              $slider.slick("slickFilter", ".non_rolled");
              currentFilter = ".non_rolled";
            }

            // $slider.slick('slickSetOption', 'fade', true, true);
          }

          // ✅ Go to the matching image based on alt
          const targetAlt = event.target.value.trim().toLowerCase();

          setTimeout(function () {
            let targetIndex = null;
            $(".image_slider .slide_child:visible").each(function (index) {
              const alt = $(this)
                .find("img.mainImg")
                .attr("alt")
                ?.trim()
                .toLowerCase();
              if (alt && alt === targetAlt) {
                targetIndex = index;
                return false; // break loop
              }
            });

            if (targetIndex !== null) {
              $slider.slick("slickGoTo", targetIndex);
            }
          }, 50);

          // Optional: fade back in
          setTimeout(() => $slider.css("opacity", 1), 200);
        }, 400);
        //// TEST 1 ////
      });
    });
  //following function will run when value of Frame Colour option is changed
  document
    .querySelectorAll('input[name^="Frame Colour"]')
    .forEach(function (selectElement) {
      selectElement.addEventListener("change", function (event) {
        console.log("Frame Colour option changed:", event.target.value);
        if (event.target.value == "Classic Black Frame") {
          //change frame border image respective to the selected color
          $(".slide_child").find(".main").css({
            "border-image":
              "url('https://cdn.shopify.com/s/files/1/0874/3016/8858/files/frame_black_26x26_9e780e5d-510f-4f8b-8023-049c6ab5bea0.png?v=1716473301') 66 / 10 / 1",
            "-o-border-image":
              "url('https://cdn.shopify.com/s/files/1/0874/3016/8858/files/frame_black_26x26_9e780e5d-510f-4f8b-8023-049c6ab5bea0.png?v=1716473301') 66 / 10 / 1",
          });
        } else if (event.target.value == "Classic Brown Frame") {
          //canFrame
          //change frame border image respective to the selected color
          $(".slide_child").find(".main").css({
            "border-image":
              "url('https://cdn.shopify.com/s/files/1/0874/3016/8858/files/frame_brown_24x24_b1ab1988-010f-4780-b926-9906dbb6a12c.png?v=1716472579') 66 / 10 / 1",
            "-o-border-image":
              "url('https://cdn.shopify.com/s/files/1/0874/3016/8858/files/frame_brown_24x24_b1ab1988-010f-4780-b926-9906dbb6a12c.png?v=1716472579') 66 / 10 / 1",
          });
        } else if (event.target.value == "Classic White Frame") {
          //bigBor
          //change frame border image respective to the selected color
          $(".slide_child").find(".main").css({
            "border-image":
              "url('https://cdn.shopify.com/s/files/1/0874/3016/8858/files/frame_white_test.png?v=1716478833') 66 / 10 / 1",
            "-o-border-image":
              "url('https://cdn.shopify.com/s/files/1/0874/3016/8858/files/frame_white_test.png?v=1716478833') 66 / 10 / 1",
          });
        }
      });
    });

  //zoom icon click event
  if ($(window).width() > 1) {
    $(".image_slider .slide_child .zoomIcon").click(function () {
      $(this).parent().toggleClass("zoomed");
      if ($(this).find("i").hasClass("fa-search-plus")) {
        $(this)
          .find("i")
          .removeClass("fa-search-plus")
          .addClass("fa-search-minus");
      } else {
        $(this)
          .find("i")
          .removeClass("fa-search-minus")
          .addClass("fa-search-plus");
      }
    });
  }

  //sliders

  //homepage new releases
  $(".home_new_releases_main").each(function () {
    const $section = $(this);

    const $slider = $section.find(".bottoms .slider");
    const $prevArrow = $section.find(".tops .arrow_container .arrows .prev");
    const $nextArrow = $section.find(".tops .arrow_container .arrows .next");

    $slider.slick({
      slidesToShow: 3.3,
      arrows: true,
      prevArrow: $prevArrow,
      nextArrow: $nextArrow,
      dots: false,
      autoplay: false,
      infinite: false,
      speed: 400,
      adaptiveHeight: true,
      draggable: false,
      variableWidth: false,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 750,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 500,
          settings: {
            slidesToShow: 1.35,
          },
        },
      ],
    });
  });
  //homepage new releases

  // $('.home_og_painting .bottoms .slider').slick({
  //     slidesToShow: 3.3,
  //     arrows: true,
  //     prevArrow: $('.home_og_painting .tops .arrow_container .arrows .prev'),
  //     nextArrow: $('.home_og_painting .tops .arrow_container .arrows .next'),
  //     dots: false,
  //     autoplay: false,
  //     infinite: false,
  //     speed: 400,
  //     adaptiveHeight: true,
  //     draggable: false,
  //     responsive: [
  //       {
  //         breakpoint: 992,
  //         settings: {
  //           slidesToShow: 2,
  //         },
  //       },
  //       {
  //         breakpoint: 750,
  //         settings: {
  //           slidesToShow: 2,
  //         },
  //       },
  //       {
  //         breakpoint: 500,
  //         settings: {
  //           slidesToShow: 1,
  //         },
  //       },
  //     ],
  //   });

  // $(".prd_images .top_section .image_slider").on("afterChange", function(event, slick, currentSlide, nextSlide) {
  //     console.log(currentSlide);
  //     if (slick.$slides.length-1 == currentSlide) {
  //       console.log("last slide");
  //       $(".prodMediaOutter .nextR").click(function(){
  //         console.log("test");
  //         $(".prd_images .top_section .image_slider").slick("slickGoTo", 0);
  //       })
  //     }
  //     if (currentSlide === 0) {
  //       console.log("last slide");
  //       $(".prodMediaOutter .prevR").click(function(){
  //         console.log("test");
  //         $(".prd_images .top_section .image_slider").slick("slickGoTo", slick.$slides.length-1);
  //       })
  //     }
  // });
  // $(".prd_images .bottom_section .image_slider").slick({
  //     infinite: false,
  //     autoplay: false,
  //       // autoplaySpeed: 5000,
  //     slidesToShow: 4,
  //     slidesToScroll: 1,
  //     arrows: false,
  //     asNavFor: '.prd_images .top_section .image_slider',
  //     focusOnSelect: true,
  //     responsive: [
  //         {
  //             breakpoint: 1500,
  //             settings: {
  //                 centerMode: false,
  //                 slidesToShow: 3,
  //             }
  //         },
  //         {
  //             breakpoint: 1400,
  //             settings: {
  //                 centerMode: false,
  //                 slidesToShow: 3,
  //             }
  //         }
  //     ]
  // });

  $("#open_modal_painting").on("click", function () {
    $("body").addClass("overflow_hidden");
    $("#modalOverlayPainting").fadeIn();
  });
  $("#open_modal_print").on("click", function () {
    $("body").addClass("overflow_hidden");
    $("#modalOverlayPrint").fadeIn();
  });
  $("#open_modal_inquire").on("click", function () {
    $("body").addClass("overflow_hidden");
    $("#modalOverlayInquire").fadeIn();
  });

  // Close modal when the close icon is clicked
  $(".closeModal").on("click", function () {
    $("body").removeClass("overflow_hidden");
    $("#modalOverlayPainting").fadeOut();
    $("#modalOverlayPrint").fadeOut();
    $("#modalOverlayInquire").fadeOut();
  });

  //dropdown infos
  $(".dropdown_infos .block:first").addClass("active");
  $(".dropdown_infos .block:first").find(".answer").slideDown();
  $(".dropdown_infos .block .inline").click(function () {
    if ($(this).parent().parent().hasClass("active")) {
      $(this).parent().parent().removeClass("active");
      $(this).parent().parent().find(".answer").slideUp();
    } else {
      $(".dropdown_infos .block").removeClass("active");
      $(".dropdown_infos .block").find(".answer").slideUp();
      $(this).parent().parent().addClass("active");
      $(this).parent().parent().find(".answer").slideDown();
    }
  });

  //setting tilte in local storage for the enquiry form
  // var productTitle = document.getElementById('product_title_inquiry').innerText;

  // // Save the fetched value to local storage
  // localStorage.setItem('productTitle', productTitle);
  // console.log("stored enqiry title: " + localStorage.getItem('productTitle'));

  // function pre_loadd(){
  //     var storedProductTitle = localStorage.getItem('productTitle');

  //   if (storedProductTitle) {
  //     document.getElementById('form_input_0').value = storedProductTitle;
  //   }else{
  //     document.getElementById('form_input_0').value = 'storedProductTitle';
  //     }
  //     console.log("product tile: " + storedProductTitle);
  // }

  // setTimeout(pre_loadd, 3200);

  // function pollForFormElements() {
  //     console.log("poll2");
  //     var iframe = document.getElementById('T49_HnbPKCHr8tnQBoLyZw').getElementsByTagName('iframe')[0];
  //     if (iframe) {
  //         var iframeDocument = iframe.contentDocument || iframe.contentWindow.document;
  //         var textField = iframeDocument.getElementById('form_input_0');
  //         if (textField) {
  //             var storedProductTitle = localStorage.getItem('productTitle');
  //             textField.value = storedProductTitle;
  //         } else {
  //             setTimeout(pollForFormElements, 100); // Poll again after 100ms
  //         }
  //     } else {
  //         setTimeout(pollForFormElements, 100); // Poll again after 100ms
  //     }
  // }

  // // Start polling when the DOM is ready
  // pollForFormElements();
  // document.addEventListener('DOMContentLoaded', function() {
  //     console.log("poll");
  //     pollForFormElements();
  // });

  //increasing width of the image of original paintings
  // if ($('.orignal_paintings_width').length > 0) {
  //     // Loop through each element
  //     $('.orignal_paintings_width').each(function() {
  //       // Get the current width of the element
  //       var currentWidth = $(this).width();
  //       // Calculate the new width by increasing it by 25%
  //       var newWidth = currentWidth * 1.15;
  //       // Set the new width to the element
  //       $(this).width(newWidth);
  //     });
  // }

  //variant seatch click with globo product option app//
  // $(document).off('click.gpoSwatchFix').on('click.gpoSwatchFix', '.gpo-swatches', function (e) {
  //     // Defer your custom logic to ensure Globo's own handler runs first
  //     setTimeout(() => {
  //         const $input = $(this).find('input[type="radio"]').first();
  //         $input.attr('previous-value', 'checked'); // may or may not be needed if Globo does it

  //         const $img = $(this).find('.gpo-swatch__image').first();
  //         let imgSrc = $img.attr('src');

  //         if (imgSrc) {
  //             const cleanUrl = imgSrc.split('?')[0];
  //             console.log("cleanUrl new:", cleanUrl);
  //         }
  //     }, 0); // allows Globo’s default click behavior to complete first
  // });

  //test 2
  // $(document).off('click.gpoSwatchFix').on('click.gpoSwatchFix', '.gpo-swatches', function () {
  //     setTimeout(() => {
  //         if($(this).hasClass("active")){
  //             //removing active gpo active
  //             $(".gpo-swatches").removeClass("active");
  //             console.log("has active class");
  //         }else{
  //             console.log("doesn't have active class");
  //             const $input = $(this).find('input[type="radio"]').first();
  //             const $img = $(this).find('.gpo-swatch__image').first();
  //             let imgSrc = $img.attr('src');

  //             if (imgSrc) {
  //                 //removing active gpo active
  //                 $(".gpo-swatches").removeClass("active");
  //                 $(this).addClass("active");

  //                 const cleanUrl = imgSrc.split('?')[0];
  //                 console.log("cleanUrl test 2:", cleanUrl);

  //                 // Find all ".main" elements inside ".grid__item.product__media-wrapper"
  //                 $('.grid__item.product__media-wrapper .main').each(function () {
  //                     const $main = $(this);

  //                     // Update the <img> inside .main
  //                     $main.find('img.mainImg').attr('src', cleanUrl);

  //                     // Update background-image of .bdrImg inside .main
  //                     $main.find('.bdrImg').css('background-image', `url('${cleanUrl}')`);
  //                 });
  //             }
  //         }
  //     }, 0);
  // });

  //test 2

  //test 3
  // let isSwatchHandling = false;

  // $(document).off('click.gpoSwatchFix').on('click.gpoSwatchFix', '.gpo-swatches', function (e) {
  //     if (isSwatchHandling) return; // prevent second trigger
  //     isSwatchHandling = true;

  //     const $swatch = $(this);

  //     // Toggle active class
  //     const isActive = $swatch.hasClass("active");

  //     $(".gpo-swatches").removeClass("active");

  //     if (!isActive) {
  //         $swatch.addClass("active");
  //         console.log("Added active class!!");

  //         const $img = $swatch.find('.gpo-swatch__image').first();
  //         const imgSrc = $img.attr('src');

  //         if (imgSrc) {
  //             const cleanUrl = imgSrc.split('?')[0];
  //             console.log("cleanUrl:", cleanUrl);

  //             $('.grid__item.product__media-wrapper .main').each(function () {
  //                 const $main = $(this);
  //                 $main.find('img.mainImg').attr('src', cleanUrl);
  //                 $main.find('.bdrImg').css('background-image', `url('${cleanUrl}')`);
  //             });
  //         }
  //     } else {
  //         console.log("Removed active class!");
  //     }

  //     setTimeout(() => {
  //         isSwatchHandling = false;
  //     }, 50); // short delay to reset the flag
  // });
  //test 3

  // //test 4
  // let isSwatchHandling = false;
  // $(document).off('click.gpoSwatchFix').on('click.gpoSwatchFix', '.gpo-swatches', function (e) {
  //     if (isSwatchHandling) return;
  //     isSwatchHandling = true;

  //     const $swatch = $(this);
  //     const isActive = $swatch.hasClass("active");

  //     $(".gpo-swatches").removeClass("active");

  //     if (!isActive) {
  //         // Add active class
  //         $swatch.addClass("active");
  //         console.log("Added active class!");

  //         const $img = $swatch.find('.gpo-swatch__image').first();
  //         const imgSrc = $img.attr('src');

  //         if (imgSrc) {
  //             const cleanUrl = imgSrc.split('?')[0];
  //             console.log("cleanUrl:", cleanUrl);

  //             $('.grid__item.product__media-wrapper .main').each(function () {
  //                 const $main = $(this);
  //                 $main.find('img.mainImg').attr('src', cleanUrl);
  //                 $main.find('.bdrImg').css('background-image', `url('${cleanUrl}')`);
  //             });
  //         }
  //     } else {
  //         console.log("Removed active class!");

  //         // If NO other swatch is now active, reset to default image
  //         const $activeSwatches = $('.gpo-swatches.active');
  //         if ($activeSwatches.length === 0) {
  //             const defaultImage = $('#fetch-default-image').data('default-image');
  //             if (defaultImage) {
  //                 console.log("Resetting to default image:", defaultImage);

  //                 $('.grid__item.product__media-wrapper .main').each(function () {
  //                     const $main = $(this);
  //                     $main.find('img.mainImg').attr('src', defaultImage);
  //                     $main.find('.bdrImg').css('background-image', `url('${defaultImage}')`);
  //                 });
  //             }
  //         }
  //     }

  //     setTimeout(() => {
  //         isSwatchHandling = false;
  //     }, 50);
  // });
  // //test 4

  //test 5
  let isSwatchHandling = false;
  $(document)
    .off("click.gpoSwatchFix")
    .on("click.gpoSwatchFix", ".gpo-swatches", function (e) {
      if (isSwatchHandling) return;
      isSwatchHandling = true;

      const $swatch = $(this);
      const isActive = $swatch.hasClass("active");

      $(".gpo-swatches").removeClass("active");

      if (!isActive) {
        // Add active class
        $swatch.addClass("active");
        console.log("Added active class!");

        // const $img = $swatch.find('.gpo-swatch__image').first();
        const $img = $swatch.find(".swatch-image").first();
        const imgSrc = $img.attr("src");

        if (imgSrc) {
          const cleanUrl = imgSrc.split("?")[0];
          console.log("cleanUrl:", cleanUrl);

          $(".grid__item.product__media-wrapper .main").each(function () {
            const $main = $(this);
            $main.find("img.mainImg").attr("src", cleanUrl);
            $main.find(".bdrImg").css("background-image", `url('${cleanUrl}')`);
          });
        }
      } else {
        console.log("Removed active class!");

        // If NO other swatch is now active, reset to default image
        const $activeSwatches = $(".gpo-swatches.active");
        if ($activeSwatches.length === 0) {
          const defaultImage = $("#fetch-default-image").data("default-image");
          if (defaultImage) {
            console.log("Resetting to default image:", defaultImage);

            $(".grid__item.product__media-wrapper .main").each(function () {
              const $main = $(this);
              $main.find("img.mainImg").attr("src", defaultImage);
              $main
                .find(".bdrImg")
                .css("background-image", `url('${defaultImage}')`);
            });
          }
        }
      }

      setTimeout(() => {
        isSwatchHandling = false;
      }, 50);
    });
  //test 5

  //hiding powered by
  setTimeout(function () {
    $(".gpo-form__group").each(function () {
      const $group = $(this);
      const html = $group.html();

      // Check if the content includes "Powered by Globo Product Options"
      if (
        html.includes("Powered by") &&
        html.includes("Globo Product Options")
      ) {
        $group.remove(); // Remove the entire group
      }
    });
  }, 50);
  //hiding powered by
  //variant seatch click with globo product option app//

  ////////////  PRODUCT PAGE  ////////////

  ////////////  COLLECTION PAGE  ////////////
  $(".pretend_close").click(function () {
    $(".real_close").click();
    $(".mobile-facets__details").removeAttr("open");
    $(".mobile-facets__details:first").attr("open", true);
  });

  function handleDetailsOpenAttribute() {
    if ($(window).width() > 749) {
      $(".mobile-facets__details").removeAttr("open");
      $(".mobile-facets__details:first").attr("open", true);
    }
  }

  // Run on initial load
  handleDetailsOpenAttribute();

  // Run on window resize
  $(window).resize(handleDetailsOpenAttribute);

  // Event delegation for click on .mobile-facets__details
  $(document).on("click", ".mobile-facets__details summary", function (e) {
    if ($(window).width() > 749) {
      e.preventDefault();
      if (!$(this).parent().hasClass("menu-opening")) {
        $(".mobile-facets__details").removeClass("menu-opening");
        $(this).parent().addClass("menu-opening");
        $(".mobile-facets__details").removeAttr("open");
        $(this).parent().attr("open", true);
      }
    }
  });

  ////test

  function resizeMasonryItem(item) {
    /* Get the grid object, its row-gap, and the size of its implicit rows */
    var grid = document.getElementsByClassName("product-grid")[0],
      rowGap = parseInt(
        window.getComputedStyle(grid).getPropertyValue("grid-row-gap")
      ),
      // rowGap = 0,
      rowHeight = parseInt(
        window.getComputedStyle(grid).getPropertyValue("grid-auto-rows")
      );

    /*
     * Spanning for any brick = S
     * Grid's row-gap = G
     * Size of grid's implicitly create row-track = R
     * Height of item content = H
     * Net height of the item = H1 = H + G
     * Net height of the implicit row-track = T = G + R
     * S = H1 / T
     */
    var rowSpan = Math.ceil(
      (item.querySelector(".product-card-wrapper").getBoundingClientRect()
        .height +
        rowGap) /
        (rowHeight + rowGap)
    );

    /* Set the spanning as calculated above (S) */
    item.style.gridRowEnd = "span " + rowSpan;

    /* Make the images take all the available space in the cell/item */
    item.querySelector(".product-card-wrapper").style.height =
      rowSpan * 10 + "px";
  }

  /**
   * Apply spanning to all the masonry items
   *
   * Loop through all the items and apply the spanning to them using
   * `resizeMasonryItem()` function.
   *
   * @uses resizeMasonryItem
   */
  function resizeAllMasonryItems() {
    // Get all item class objects in one list
    var allItems = document.getElementsByClassName("grid__item");

    /*
     * Loop through the above list and execute the spanning function to
     * each list-item (i.e. each masonry item)
     */
    for (var i = 0; i > allItems.length; i++) {
      resizeMasonryItem(allItems[i]);
    }
  }

  /**
   * Resize the items when all the images inside the masonry grid
   * finish loading. This will ensure that all the content inside our
   * masonry items is visible.
   *
   * @uses ImagesLoaded
   * @uses resizeMasonryItem
   */
  function waitForImages() {
    // var allItems = document.getElementsByClassName('grid__item');
    // for(var i=0;i<allItems.length;i++){
    //     imagesLoaded( allItems[i], function(instance) {
    //     var item = instance.elements[0];
    //     resizeMasonryItem(item);
    //     } );
    // }
  }

  /* Resize all the grid items on the load and resize events */
  // var masonryEvents = ['load', 'resize'];
  //     masonryEvents.forEach( function(event) {
  //     window.addEventListener(event, resizeAllMasonryItems);

  // } );

  /* Do a resize once more when all the images finish loading */
  waitForImages();

  function run_the_code() {
    // var masonryEvents = ['load', 'resize'];
    // masonryEvents.forEach( function(event) {
    //     window.addEventListener(event, resizeAllMasonryItems);
    // } );
    // /* Do a resize once more when all the images finish loading */
    // waitForImages();
  }

  // Event listener to clear localStorage on page unload if leaving the collection page
  // $(window).on('unload', function() {
  //     if (!isCollectionPage()) { // Check if leaving collection page
  //         clearCurrentPage();
  //     }
  // });

  // // Function to identify if current page is a collection page
  // function isCollectionPage() {
  //     // Replace with your logic to identify collection pages
  //     return window.location.pathname.includes('/collections/');
  // }
  // $('.js-load-more-product-collection').on('click', function(){
  //   var $this =$(this),totalPages = parseInt($('[data-total-pages]').val()),currentPage = parseInt($('[data-current-page]').val());
  //     //   $this.attr('disabled', true);
  //     //   $this.find('[load-more-text]').addClass('hide');
  //   // $this.find('[loader]').removeClass('hide');
  //   currentPage = currentPage + 1;
  //   $('[data-current-page]').val(currentPage);

  //   var nextUrl = $('[data-next-url]').val().replace(/page=[0-9]+/,'page='+currentPage);
  //   //changing current page value on frontend

  //   $.ajax({
  //     url: nextUrl,
  //     type: 'GET',
  //     dataType: 'html',
  //     success: function(responseHTML){
  //       $('.product-grid').append($(responseHTML).find('.product-grid').html());
  //       setTimeout(run_the_code, 200);
  //     },
  //     complete: function() {

  //       if(currentPage == totalPages) {
  //         // alert();
  //         //  $this.attr('disabled', false);
  //         //  $this.find('[load-more-text]').removeClass('hide');
  //         //  $this.find('[loader]').addClass('hide');
  //         $(".js-load-more-product-collection").removeClass("keep_loading");
  //         $('.load-more_wrap').hide();
  //       }
  //     }
  //   })
  // });

  // Function to get the collection name from the URL
  // initialize();
  // setTimeout(function() {
  //     initialize();
  // }, 1200);

  $(window).on("pageshow", function () {
    console.log("Page show");
    initialize();
  });
  // Function to check if current collection matches stored collection
  function initialize() {
    //   if (window.location.pathname.includes("/collections/")) {
    //     checkCurrentCollection();
    //   }
    if (window.location.pathname.includes("/collections/")) {
      checkCurrentCollection();
      // console.log("run from collection page");
    } else if (window.location.pathname.includes("/products/")) {
      // console.log("productPage");
    } else {
      localStorage.removeItem("currentCollection");
      localStorage.removeItem("currentPage");
      localStorage.removeItem("currentPrdScrollID");
    }
  }
  $(document).on("click", ".scroll_id_save_click", function () {
    // $('.scroll_id_save_click').on('click', function() {
    if (window.location.pathname.includes("/collections/")) {
      var scroll_id = $(this).attr("data-scroll-id");
      console.log("cliekc product");
      localStorage.setItem("currentPrdScrollID", scroll_id);
    }
  });

  if (
    !window.location.pathname.includes("/collections/") &&
    !window.location.pathname.includes("/products/")
  ) {
    localStorage.removeItem("currentPrdScrollID");
  }

  function getCurrentCollectionName() {
    var pathArray = window.location.pathname.split("/");
    var collectionIndex = pathArray.indexOf("collections");
    if (collectionIndex !== -1 && collectionIndex + 1 < pathArray.length) {
      return pathArray[collectionIndex + 1];
    }
    return null; // Return null if collection name not found
  }

  // Function to check if current collection matches stored collection
  async function checkCurrentCollection() {
    var currentCollection = getCurrentCollectionName();
    // console.log("current collection: " + currentCollection);
    var storedCollection = localStorage.getItem("currentCollection");
    var storedPage = parseInt(localStorage.getItem("currentPage")) || 1;
    var storedProductId = localStorage.getItem("currentPrdScrollID");

    if (currentCollection === storedCollection) {
      // Do something if current collection matches stored collection
      // console.log('Current collection matches stored collection:', currentCollection);

      // localStorage.setItem('currentPage', 1);
      var currentPage = 1;
      var currentProdGrid = "";
      var totalPages = parseInt($("[data-total-pages]").val());
      // console.log("totalpages: " + totalPages);
      console.log(
        "Current Page: " +
          currentPage +
          "\nStored Page: " +
          storedPage +
          "\ntotal pages: " +
          totalPages
      );

      const loadMoreRequests = [];

      //setting current page in load more releated hidden element
      $("[data-current-page]").val(storedPage);

      while (currentPage < storedPage) {
        currentPage++;
        localStorage.setItem("currentPage", currentPage);
        var nextUrl = $("[data-next-url]")
          .val()
          .replace(/page=[0-9]+/, "page=" + currentPage);

        loadMoreRequests.push(
          $.ajax({
            url: nextUrl,
            type: "GET",
            dataType: "html",
          }).done(function (responseHTML) {
            currentProdGrid += $(responseHTML).find(".product-grid").html();
          })
        );

        // console.log('Current collection clicked!!');
        // console.log('storedPage!! ', storedPage);
      }

      // Wait for all AJAX requests to complete
      await Promise.all(loadMoreRequests);

      // Append the collected product grids to the page
      $(".product-grid").append(currentProdGrid);
      setTimeout(run_the_code, 200);

      // Scroll to 90% of the product-grid height
      function scroll_to() {
        var $productGrid = $(".product-grid");
        // $('html, body').animate({
        //     scrollTop: $productGrid.offset().top + ($productGrid.height() * 0.95)
        // }, 700);
        if (storedProductId) {
          var $storedProduct = $("#" + storedProductId);
          if ($storedProduct.length) {
            // $('html, body').animate({
            //     scrollTop: $storedProduct.offset().top - ($(window).height() * 0.25)
            // }, 800);
            window.scrollTo({
              top: $storedProduct.offset().top - $(window).height() * 0.25,
              behavior: "auto", // No animation
            });
            console.log("Scrolled to:", $storedProduct);
            console.log("Scrolled id:", storedProductId);
          } else {
            // $('html, body').animate({
            //     scrollTop: $productGrid.offset().top - ($(window).height() * 0.25)
            // }, 800);
            window.scrollTo({
              top: $productGrid.offset().top + $productGrid.height() * 0.95,
              behavior: "auto", // No animation
            });
            console.log("Not Scrolled to:", $storedProduct);
            console.log("Not Scrolled id:", storedProductId);
          }
          console.log("scrolllllled: ", $storedProduct);
        } else {
          var $productGrid = $(".product-grid");
          // $('html, body').animate({
          //     scrollTop: $productGrid.offset().top + ($productGrid.height() * 0.95)
          // }, 700);
          window.scrollTo({
            top: $productGrid.offset().top + $productGrid.height() * 0.95,
            behavior: "auto", // No animation
          });
        }
      }
      if (storedPage > 1) {
        setTimeout(scroll_to, 320);
        console.log("alertttttt");
      }
      if (currentPage == totalPages) {
        $(".js-load-more-product-collection").removeClass("keep_loading");
        $(".load-more_wrap").hide();
      }

      // console.log("currentProdGrid: " + currentProdGrid);
    } else {
      // console.log('Current collection does not match stored collection');
      localStorage.setItem("currentCollection", currentCollection);
      localStorage.setItem("currentPage", 1);
      // localStorage.removeItem('currentPrdScrollID', 1);
    }
  }
  // if (window.location.pathname.includes('/collections/')) {
  //     checkCurrentCollection();
  // }
  // $(document).on('click', '.scroll_id_save_click', function() {
  // // $('.scroll_id_save_click').on('click', function() {
  //     if (window.location.pathname.includes('/collections/')) {
  //         var scroll_id = $(this).attr("data-scroll-id");
  //         console.log('cliekc product');
  //         localStorage.setItem('currentPrdScrollID', scroll_id);
  //     }
  // });

  var isLoading = false;
  let noMorePages = false;
  // $('.js-load-more-product-collection').on('click', function() {
  $(document).on(
    "click",
    ".js-load-more-product-collection.keep_loading",
    function () {
      if (isLoading) return; // Prevent further execution if already loading

      isLoading = true;
      var $this = $(this),
        totalPages = parseInt($("[data-total-pages]").val()),
        currentPage = parseInt($("[data-current-page]").val());

      currentPage = currentPage + 1;

      $("[data-current-page]").val(currentPage);
      console.log("current url: " + $("[data-next-url]").val());
      // var nextUrl = $('[data-next-url]').val().replace(/page=[0-9]+/, 'page=' + currentPage);
      var collection = $(this).attr("collection");
      var sortBy = $("#SortBy").val();
      var nextUrl =
        "/collections/" +
        collection +
        "?page=" +
        (currentPage + 1) +
        "&sort_by=" +
        sortBy;
      console.log("new url: " + nextUrl);

      // Store current page state in localStorage
      localStorage.setItem("currentPage", currentPage);

      // Perform AJAX request to load more products
      $.ajax({
        url: nextUrl,
        type: "GET",
        dataType: "html",
        success: function (responseHTML) {
          const $response = $(responseHTML);
          $(".product-grid").append(
            $(responseHTML).find(".product-grid").html()
          );
          setTimeout(run_the_code, 200);

          var showResponse = $(responseHTML).find(".product-grid").html();
          // console.log("showResponse: " + showResponse);

          const updatedNextUrl = $response.find("[data-next-url]").val();
          if (updatedNextUrl) {
            $("[data-next-url]").val(updatedNextUrl);
            $this.prop("disabled", false).text("Load More");
            isLoading = false;
          } else {
            $(".load-more_wrap").hide();
            noMorePages = true;
            isLoading = false;
          }
        },
        complete: function () {
          isLoading = false; // Reset the loading flag after completion

          if (currentPage == totalPages) {
            $(".js-load-more-product-collection").removeClass("keep_loading");
            $(".load-more_wrap").hide();
          }
        },
      });
    }
  );

  //calling loadmore funtion when page is scrolled
  // $(document).on('click', '.js-load-more-product-collection.keep_loading', function(e) {
  //     e.preventDefault();
  //     console.log("Button clicked via scroll trigger");

  //     // Insert your existing load more logic here...
  //     $('.js-load-more-product-collection').trigger('click');
  // });
  var debounceTimeout;

  function checkLoadMoreVisibility() {
    // alert();
    var $button = $(".js-load-more-product-collection.keep_loading");
    // console.log("button check ");
    if ($button.length === 0) return; // Exit if button doesn't exist

    // console.log("button exists ");

    var buttonTop = $button.offset().top;
    var windowHeight = $(window).height();
    var scrollTop = $(window).scrollTop();

    var distanceToViewportBottom = buttonTop - (scrollTop + windowHeight);

    // Check if button is within 50px of the viewport bottom
    if (distanceToViewportBottom <= 1650 && !isLoading) {
      // console.log("distance is 500");

      $button.click();
    }
    // console.log("checkLoadMoreVisibility");
  }

  window.addEventListener("scroll", function () {
    clearTimeout(debounceTimeout);

    debounceTimeout = setTimeout(function () {
      checkLoadMoreVisibility();
    }, 10); // Debounce to prevent rapid firing
  });
  // setTimeout(function() {
  //     console.log("5 seconds");
  //     window.addEventListener('scroll', function() {
  //         clearTimeout(debounceTimeout);

  //         debounceTimeout = setTimeout(function() {
  //             checkLoadMoreVisibility();
  //         }, 10); // Debounce to prevent rapid firing
  //     });
  // }, 400);

  // window.addEventListener('scroll', function() {
  //     clearTimeout(debounceTimeout);

  //     debounceTimeout = setTimeout(function() {
  //         var scrollTop = window.scrollY || document.documentElement.scrollTop;
  //         var windowHeight = window.innerHeight || document.documentElement.clientHeight;
  //         var documentHeight = document.documentElement.scrollHeight;

  //         var screenWidth = $(window).width();
  //         if (screenWidth > 1280) {
  //         if (scrollTop + windowHeight >= documentHeight - 700 && !isLoading) {
  //             $('.js-load-more-product-collection.keep_loading').click();
  //         }

  //         } else if (screenWidth <= 1280 && screenWidth > 990) {
  //         if (scrollTop + windowHeight >= documentHeight - 1200 && !isLoading) {
  //             $('.js-load-more-product-collection.keep_loading').click();
  //         }

  //         } else if (screenWidth <= 990 && screenWidth > 320) {
  //         if (scrollTop + windowHeight >= documentHeight - 1700 && !isLoading) {
  //             $('.js-load-more-product-collection.keep_loading').click();
  //         }

  //         } else {
  //         if (scrollTop + windowHeight >= documentHeight - 2100 && !isLoading) {
  //             $('.js-load-more-product-collection.keep_loading').click();
  //         }

  //         }
  //     }, 50); // 150ms debounce to prevent rapid firing
  // });

  // window.addEventListener('scroll', function() {
  //     var scrollTop = window.scrollY || document.documentElement.scrollTop;
  //     var windowHeight = window.innerHeight || document.documentElement.clientHeight;
  //     var documentHeight = document.documentElement.scrollHeight;

  //     var screenWidth = $(window).width();
  //     if (screenWidth > 1280) {
  //       if (scrollTop + windowHeight >= documentHeight - 700) {
  //         // loadProducts();
  //         // console.log("greater than 1280px");
  //         $('.js-load-more-product-collection.keep_loading').click();
  //       }

  //     }
  //     else if (screenWidth <= 1280 && screenWidth > 990) {
  //       if (scrollTop + windowHeight >= documentHeight - 1200) {
  //         // console.log("less than 1280px && greater than 990");
  //         $('.js-load-more-product-collection.keep_loading').click();
  //       }

  //     }
  //     else if (screenWidth <= 990 && screenWidth > 320) {
  //       if (scrollTop + windowHeight >= documentHeight - 1700) {
  //         // console.log("greater than 990px and greater than 320");
  //         $('.js-load-more-product-collection.keep_loading').click();
  //       }

  //     }
  //     else {
  //       if (scrollTop + windowHeight >= documentHeight - 2100) {
  //         // console.log("less than 320px");
  //         $('.js-load-more-product-collection.keep_loading').click();
  //       }

  //     }
  // });

  ////////////  COLLECTION PAGE  ////////////

  ////////////  HEADER CHANGING FLAGS  ////////////

  // Define the class to select the buttons
  var buttonClass = ".localization-form__select.countryyyy";

  // Define the image URL
  var imageUrlCanada =
    "https://cdn.shopify.com/s/files/1/0874/3016/8858/files/download.svg?v=1718635779";
  var imageUrlUSA =
    "https://cdn.shopify.com/s/files/1/0874/3016/8858/files/um-YZEEIF9X.svg?v=1718635785";

  // Select all buttons with the specified class
  // $(buttonClass).each(function() {
  //     // Find the span element within the button
  //     console.log("runFlag");
  //     var span = $(this).find('span');

  //     // Check if the span element exists and contains the word "Canada"
  //     if (span.length && span.text().includes("Canada")) {
  //         // Replace the word "Canada" with an image
  //         var updatedText = span.html().replace(/Canada/g, '<img src="' + imageUrlCanada + '" alt="Canada">');
  //         span.html(updatedText);
  //     }
  //     if (span.length && span.text().includes("United States")) {
  //         // Replace the word "United States" with an image
  //         var updatedText = span.html().replace(/United States/g, '<img src="' + imageUrlUSA + '" alt="Canada">');
  //         span.html(updatedText);
  //     }
  // });

  ////////////  HEADER CHANGING FLAGS  ////////////

  //wishlist page
  $(".wishlist-view .icon-wishlist-list-view").addClass("change__view-active");
  $(".wishlist-view .icon-wishlist-grid-view").removeClass(
    "change__view-active"
  );
  $(".wishlist-view .icon-wishlist-list-view").click();
});

//filtering issue which diable load more button
// $(document).ajaxComplete(function(event, xhr, settings) {
//     // Rebind your Load More button and scroll check after any AJAX request completes
//     console.log("Rebinding after AJAX request");
//     bindLoadMoreFunctionality(); // Call a function that rebinds the load more click handler
// });

// Call this function to bind/rebind your Load More button

//product page - customize button and form

//product page - customize button and form
